import React, { FunctionComponent, useState } from 'react'
import style from './enterVehicleCodeModalWrapper.css'
import useTranslation from '../../hooks/useTranslation'
import EnterVehicleCodeForm from '../enter-vehicle-code-form'
import Modal, { ModalClosingButton } from '../modal'

export type Props = {
    submitVehicleCode: Function
    submitVin: Function
    activeState: [boolean, (isActive: boolean) => void]
    brand: string
    vinEnabled: boolean
    vehicleCodeEnabled: boolean
}

type IdentificationType = 'vehicleCode' | 'vin'

const EnterVehicleCodeModalWrapper: FunctionComponent<Props> = (props) => {
    const { submitVehicleCode, submitVin, activeState, brand, vinEnabled, vehicleCodeEnabled } = props
    const [identificationType, setIdentificationType] = useState<IdentificationType>('vehicleCode')
    const { t } = useTranslation()
    const [modalIsActive, setModalIsActive] = activeState

    const onSubmitVehicleCode = (vehicleCode: string): void => {
        submitVehicleCode(vehicleCode)
        setModalIsActive(false)
    }

    const onSubmitVin = (vin: string): void => {
        submitVin({vin: vin})
        setModalIsActive(false)
        setIdentificationType('vehicleCode')
    }

    const closeModal = (): void => {
        setModalIsActive(false)
        setIdentificationType('vehicleCode')
    }

    const closeButtonClickHandler = (): void => {
        closeModal()
    }

    return (
        <Modal isVisible={modalIsActive} onClose={closeModal}>
            <ModalClosingButton onClick={closeButtonClickHandler} />
            <div className={style.container}>
                {vehicleCodeEnabled && vinEnabled && (<div
                        className={`${style.switchContent} ${identificationType === 'vin' ? style.vinActive : ''}`}>
                        <button
                            className={`${style.switchButton} ${identificationType === 'vehicleCode' ? style.active : ''}`}
                            onClick={() => setIdentificationType('vehicleCode')}
                            type="button"
                            data-testid="vehicle-code-switch"
                        >
                            {t(`vehicleCode.${brand}.enter.switcherLabel`)}
                        </button>
                        <button
                            className={`${style.switchButton} ${identificationType === 'vin' ? style.active : ''}`}
                            onClick={() => setIdentificationType('vin')}
                            type="button"
                            data-testid="vin-switch"
                        >
                            {t(`vin.enter.switcherLabel`)}
                        </button>
                    </div>)
                }
                {identificationType === 'vehicleCode'
                    && vehicleCodeEnabled
                    && <EnterVehicleCodeForm
                        key="vehicleCode"
                        title={t(`vehicleCode.${brand}.enter.title`)}
                        onSubmit={onSubmitVehicleCode}
                        inputLabel={t(`vehicleCode.${brand}.enter.inputLabel`)}
                        inputPlaceholder={t(`vehicleCode.${brand}.enter.placeholder`)}
                        inputDataTestId="input-vehicle-code"
                        submitCodeButtonDataTestId="submit-vehicle-code"
                        submitCodeButtonLabel={t(`vehicleCode.${brand}.enter.submitButtonLabel`)}
                        validationError={t(`vehicleCode.${brand}.enter.validationError`)}
                        requiredCodeLength={8}
                        codeInfoTitle={t(`vehicleCode.${brand}.enter.codeInfoTitle`)}
                        codeInfoDescription={t(`vehicleCode.${brand}.enter.codeInfoDescription`)}
                    />}
                {identificationType === 'vin'
                    && vinEnabled
                    && <EnterVehicleCodeForm
                        key="vin"
                        title={t(`vin.enter.title`)}
                        onSubmit={onSubmitVin}
                        inputLabel={t(`vin.enter.inputLabel`)}
                        inputPlaceholder={t(`vin.enter.placeholder`)}
                        inputDataTestId="input-vin"
                        submitCodeButtonDataTestId="submit-vin"
                        submitCodeButtonLabel={t(`vin.enter.submitButtonLabel`)}
                        validationError={t(`vin.enter.validationError`)}
                        requiredCodeLength={17}
                        codeInfoTitle={t(`vin.enter.codeInfoTitle`)}
                        codeInfoDescription={t(`vin.enter.codeInfoDescription`)}
                    />}
            </div>
        </Modal>
    )
}

export default EnterVehicleCodeModalWrapper
